import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import NewHeader from '../../components/layout/NewHeader/NewHeader'
import map from '../../assets/svg/map.svg'
import { Container, Icon } from './StoreErrorPageStyledComponents'
import { Button, Col, Row } from 'reactstrap'
import { Link, withRouter } from 'react-router-dom'

const CustomStoreError = ({ message, storeId, history }) => (
  <>
    <NewHeader showBreadcrumb={false} showScrollIcon={false}>
      <h1 className='text-center'>
        <FormattedMessage id='storeErrorPage.title' />
      </h1>
    </NewHeader>
    <Container>
      <Row>
        <Col md={{ size: 10, offset: 1 }} className='text-center'>
          <div>
            <Icon src={map} />
            <p className='mt-2'> {message} </p>
          </div>
          <Button
            color='secondary'
            className='my-3'
            onClick={() => history.push(`/store/${storeId}`)}
          >
            <FormattedMessage id='storeErrorPage.reloadStore' />
          </Button>
          <br />
          <Link className='my5' to='/home'>
            <FormattedMessage id='storeErrorPage.text' />
          </Link>
        </Col>
      </Row>
    </Container>
  </>
)

CustomStoreError.displayName = 'CustomStoreError'

CustomStoreError.propTypes = {
  message: PropTypes.string,
  storeId: PropTypes.string,
  history: PropTypes.object
}

export default withRouter(CustomStoreError)
